/**
 * Inline help copy for the Metathesaurus / Dactyl Concepts browser.
 *
 * Mirrors the QC workflow's qcHelpStrings.js: each help string is paired with
 * its QC-user-manual deep-link href so the two stay together when copy is
 * edited. The copy renders in the shared QcHelpIcon (a presentational atom; the
 * strings are page-local so a non-QC page does not import QC copy).
 *
 * Hrefs are markdown-it-anchor heading slugs (lowercased, spaces -> "-"). Avoid
 * linking to a heading with punctuation: the slug percent-encodes it and the
 * deep link then never resolves. Both targets below are clean-slug headings in
 * the manual's Dactyl Concepts tab.
 */

// The Dactyl Concepts store overview - shown on the concept list header of the
// Normalization tab.
export const QC_MANUAL_CONCEPTS_HREF =
	"/qc-user-manual#what-dactyl-concepts-are";

export const CONCEPTS_OVERVIEW_HELP =
	"Dactyl Concepts is a curated store of Dactyl terms (preferred terms) and " +
	"their synonyms. Scoped concepts drive the reviewer-mediated suggestions on " +
	"the QC Normalize step, so a synonym is rewritten to one canonical term across " +
	"every QC.";

// Shown on the concept list header of the characterization tabs (Disease,
// Anatomy, Drug class, Mechanism of action). These concepts do not rewrite
// values on the Normalize step; they characterize papers, which in turn narrows
// which normalization concepts are in scope for a paper's QC.
export const CHARACTERIZATION_OVERVIEW_HELP =
	"Characterization concepts describe what a paper is about along an axis - " +
	"disease, anatomy, drug class, or mechanism of action. Unlike normalization " +
	"concepts, they do not drive rewrites on the QC Normalize step; characterizing " +
	"a paper instead limits which normalization concepts are in scope for that " +
	"paper's QC.";

// Scope - shown next to a concept's scope pickers in the editor.
export const QC_MANUAL_CONCEPT_SCOPE_HREF =
	"/qc-user-manual#scope-and-where-a-concept-applies";

export const CONCEPT_SCOPE_HELP =
	"Scope decides where a concept suggestion applies: by tag, by tag group, or " +
	"both (combined as an AND). A concept with no scope suggests nowhere, which " +
	"keeps a term from rewriting unrelated values that share its text.";
